<template>
  <!-- 骑行轨迹 -->
  <div class="dilu-map">
    <!-- 搜索区域 -->
    <div class="search">
      <div class="searchSubmit">
        <DiluButton
          v-permission="['fenceTrajectory:select']"
          type="search"
          :title="$t('pages.operate.text97')"
          @click="search"
        ></DiluButton>
        <DiluButton
         v-permission="['fenceTrajectory:remove']"
          type="reset"
          @click="clearTrack"
          :title="$t('pages.operate.text98')"
        ></DiluButton>
      </div>
    </div>

    <div id="container"></div>
    <div class="speed">
      <div id="dilu-speed"></div>
    </div>

    <el-dialog
      :title="$t('pages.operate.text99')"
      :visible.sync="dialogTableVisible"
      width="1000px"
    >
      <div class="dialog">
        <!-- 搜索区域 -->
        <div class="search">
          <el-form
            ref="form"
            :model="iotParams"
            label-width="auto"
            class="from"
          >
            <el-form-item :label="$t('pages.operate.text100')">
              <el-input
                v-model="iotParams.devCode"
                :placeholder="$t('public.text1')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('pages.operate.text101')">
              <el-select
                v-model="iotParams.status"
                :placeholder="$t('public.text5')"
                clearable
              >
                <el-option :label="$t('pages.operate.text102')" :value="20">
                </el-option>
                <el-option :label="$t('pages.operate.text103')" :value="10">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="searchSubmit">
            <DiluButton type="search" @click="iotQueryList"></DiluButton>
            <DiluButton type="reset" @click="resetQuery"></DiluButton>
          </div>
        </div>

        <!-- 表格 -->
        <DiluTable
          :list="tableData"
          :tableConfig="tableConfig"
          :pageSize="iotParams.pageSize"
          @currentChange="currentChange"
          :total="total"
        >
          <el-table-column prop="bikeCategoryName" label="#" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="devCode"
            :label="$t('pages.operate.text100')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="onlineStatus"
            :label="$t('pages.operate.text101')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastReport"
            :label="$t('pages.operate.text104')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            :label="$t('public.text4')"
            align="center"
            width="160px"
          >
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button @click="setCart(scope.row.devCode)" type="text">{{
                  $t("pages.operate.text105")
                }}</el-button>
              </div>
            </template>
          </el-table-column>
        </DiluTable>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import startImage from "../../../assets/images/start.png";
import endImage from "../../../assets/images/cart.png";
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import * as echarts from "echarts";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      tableData: [],

      dialogTableVisible: false,
      //在线设备列表参数
      iotParams: {
        pageNum: 1, //页码
        pageSize: 5, //每页条数
        belongCustomer: "", //平台方ID
        devCode: "", //设备编码
        lastTime: "", //操作日期，数组形式[start,end]
        status: 20, //在线状态（10：在线，20：全部）
      },
      //参数
      params: {
        controllerCode: "",
        endTime: "",
        maxCounts: "",
        startTime: "",
      },
      center: [116.409788, 39.907123], //中心点
      map: null, // 地图对象
      flightPath: null, //路线
      startMarker: null, //起点
      endMarker: null, //终点
      setTime: null, //计时器
      paths: [], //轨迹
      speedList: [], //速度
      dateList: [], // 时间
      option: null, //echarst模型
      myChart: null, //echarst
      isFirst: true,
    };
  },
  components: {
    DiluButton,
    DiluTable,
  },
  computed: {
    ...mapState(["regionList", "currentRegion", "platformData"]),
  },
  destroyed() {
    let that = this;
    clearInterval(that.setTime);
  },
  mounted() {
    this.initMap();
    setTimeout(() => {
      this.iotQueryList();
      this.getGeoList();
      this.initEcharts();
      this.speed();
    }, 1000);
  },
  methods: {
    //搜索
    search() {
      this.iotParams.pageNum = 1;
      this.total = 0;
      this.selectCart();
    },
    //重置
    resetQuery() {
      this.iotParams = {
        pageNum: 1, //页码
        pageSize: 5, //每页条数
        belongCustomer: "", //平台方ID
        devCode: "", //设备编码
        lastTime: "", //操作日期，数组形式[start,end]
        status: 20, //在线状态（10：在线，20：全部）
      };
      this.iotQueryList();
    },
    //翻页
    currentChange(e) {
      this.iotParams.pageNum = e;
      this.iotQueryList()
    },
    //打开车辆选择列表
    selectCart() {
      this.dialogTableVisible = true;
    },
    //查询在线设备列表
    iotQueryList() {
      this.iotParams.belongCustomer = this.platformData.id;
      this.request.iotQueryList(this.iotParams).then((res) => {
        this.total = res.dataMaxCount;
        this.tableData = res.data.data;
      });
    },
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        if (window.google) {
          this.initEnMap();
          // 未载入谷歌地图API，则先载入API再初始化
        } else {
          // 载入谷歌地图和UI组件
          Promise.all([
            remoteLoad(
              "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
            ),
          ]).then(() => {
            this.initEnMap();
          });
        }
        // this.isGoogle = true;
      } else {
        if (window.AMap && window.AMapUI) {
          this.initCnMap();
          // 未载入高德地图API，则先载入API再初始化
        } else {
          // 载入高德地图和UI组件
          Promise.all([
            remoteLoad(
              "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
            ),
          ]).then(() => {
            this.initCnMap();
          });
        }
      }
    },
    //高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        center: that.center,
        zoom: 15,
      });
    },
    //设置高德地图点标记
    setCnMapMarker(startLatLng, endLatLng) {
      let that = this;
      if (this.startMarker && this.endMarker) {
        this.map.remove(that.endMarker);
        this.map.remove(that.startMarker);
      }
      this.startMarker = new AMap.Marker({
        position: startLatLng,
        icon: startImage,
        map: that.map,
      });

      this.endMarker = new AMap.Marker({
        position: endLatLng,
        icon: endImage,
        map: that.map,
      });
    },
    //设置高德地图轨迹
    setCnMapFlight(paths) {
      let that = this;
      if (this.flightPath) {
        this.map.remove(that.flightPath);
      }
      this.flightPath = new AMap.Polyline({
        path: paths,
        isOutline: true,
        outlineColor: "#ffeeee",
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: "#FFAE0C",
        lineJoin: "round",
        strokeStyle: "dashed",
      });
      this.flightPath.setMap(that.map);
    },
    //高德地图电子围栏
    setCnMapFence(paths, fence) {
      //多边形轮廓线的节点坐标数组
      var polygonPath = [];
      for (let i in paths) {
        polygonPath.push(new AMap.LngLat(paths[i].lng, paths[i].lat));
      }
      var polygon = new AMap.Polygon({
        path: polygonPath,
        fillColor:
          fence.status == 0
            ? "rgba(24, 144, 255, 0.2)"
            : "rgba(24, 144, 255, .07)", // 多边形填充颜色
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: fence.status == 0 ? "#1890FF" : "#A7A7A7", // 线条颜色
      });
      this.map.add(polygon);
    },
    //谷歌地图
    initEnMap() {
      this.map = new google.maps.Map(document.getElementById("container"), {
        zoom: 15,
        // center: { lat: this.center[1], lng: this.center[0] },
        mapTypeId: "terrain",
      });
    },
    //初始化图表
    initEcharts() {
      let chartDom = document.getElementById("dilu-speed");
      this.myChart = echarts.init(chartDom);
    },
    //谷歌地图设置点
    setGoogleMarker(startLatLng, endLatLng) {
      // console.log(startLatLng,endLatLng);
      if (this.startMarker && this.endMarker) {
        this.startMarker.setMap(null);
        this.endMarker.setMap(null);
      }
      this.startMarker = new google.maps.Marker({
        position: startLatLng,
        icon: startImage,
      });
      this.endMarker = new google.maps.Marker({
        position: endLatLng,
        icon: endImage,
      });
      this.startMarker.setMap(this.map);
      this.endMarker.setMap(this.map);
    },
    //设置谷歌地图路线
    setGoogleFlight(paths) {
      // console.log(paths);
      if (this.flightPath) {
        this.flightPath.setMap(null);
      }
      this.flightPath = new google.maps.Polyline({
        path: paths,
        geodesic: true,
        strokeColor: "#FFAE0C",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
      this.flightPath.setMap(this.map);
    },
    //设置谷歌地图电子围栏
    setGoogleFence(paths, fence) {
      new google.maps.Polygon({
        paths: paths,
        strokeColor: fence.status == 0 ? "#1890FF" : "#A7A7A7",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor:
          fence.status == 0
            ? "rgba(24, 144, 255, 0.2)"
            : "rgba(24, 144, 255, .07)",
        fillOpacity: 0.35,
      }).setMap(this.map);
    },
    //选择车辆
    setCart(e) {
      let that = this;
      this.dialogTableVisible = false;
      clearInterval(that.setTime);
      this.params.controllerCode = e;
      this.params.endTime = "";
      this.params.maxCounts = "";
      this.params.startTime = "";
      this.paths = [];
      this.dateList = [];
      this.speedList = [];
      this.option = null;
      this.isFirst = true;
      if (this.startMarker && this.endMarker && this.flightPath) {
        let arr = this.regionList;
        if (arr[this.currentRegion].id != "cn") {
          this.startMarker.setMap(null);
          this.endMarker.setMap(null);
          this.flightPath.setMap(null);
        } else {
          this.map.remove(that.startMarker);
          this.map.remove(that.endMarker);
          this.map.remove(that.flightPath);
        }
      }
      this.setTime = setInterval(() => {
        this.getCartInfo();
      }, 5000);
    },
    //获取所有电子围栏
    getGeoList() {
      let that = this;
      //   this.searchParams.belongCustomerId = "" + this.platformData.id;
      this.request
        .listRidingGeoFence()
        .then((res) => {
          let arr = this.regionList;
          if (arr[this.currentRegion].id != "cn") {
            this.center = {
              lat: res.data[0].centerLat,
              lng: res.data[0].centerLon,
            };
            for (let i in res.data) {
              this.setGoogleFence(
                JSON.parse(res.data[i].geoPoint),
                res.data[i]
              );
            }
            this.map.setCenter(that.center);
          } else {
            this.center = new AMap.LngLat(
              res.data[0].centerLon,
              res.data[0].centerLat
            );
            this.map.setZoomAndCenter(15, that.center);
            for (let i in res.data) {
              this.setCnMapFence(JSON.parse(res.data[i].geoPoint), res.data[i]);
            }
          }
        });
    },
    //获取车辆信息
    getCartInfo() {
      let that = this;
      let regionList = this.regionList;
      if (!this.params.controllerCode) {
        if (regionList[this.currentRegion].id != "cn") {
          if (this.isFirst) {
            this.map.setCenter(that.center);
          }
          this.isFirst = false;
        } else {
          if (this.isFirst) {
            this.map.setZoomAndCenter(15, that.center);
          }
          this.isFirst = false;
        }
        return;
      }
      this.params.belongCustomerId = this.platformData.id;
      this.request.geoIotData(this.params).then((res) => {
        if (res.data.length < 1) {
          return;
        }
        this.params.startTime = res.data[res.data.length - 1].createTime;

        let arr = this.paths;
        let arr1 = this.speedList;
        let arr2 = this.dateList;
        for (let i in res.data) {
          if (regionList[this.currentRegion].id != "cn") {
            arr.push(new google.maps.LatLng(res.data[i].lat, res.data[i].lng));
          } else {
            arr.push(new AMap.LngLat(res.data[i].lng, res.data[i].lat));
          }
          arr1.push(res.data[i].speed);
          arr2.push(this.formatDate(new Date(res.data[i].createTime)));
        }
        this.paths = arr;
        this.speedList = arr1;
        this.dateList = arr2;
        // console.log(arr);

        let start = { lat: arr[0].lat, lng: arr[0].lng };
        let end = {
          lat: arr[arr.length - 1].lat,
          lng: arr[arr.length - 1].lng,
        };

        if (regionList[this.currentRegion].id != "cn") {
          this.setGoogleMarker(start, end);
          this.setGoogleFlight(arr);

          if (this.isFirst) {
            this.map.setCenter(end);
          }
          this.isFirst = false;
        } else {
          this.setCnMapMarker(
            new AMap.LngLat(arr[0].lng, arr[0].lat),
            new AMap.LngLat(arr[arr.length - 1].lng, arr[arr.length - 1].lat)
          );
          this.setCnMapFlight(arr);

          if (this.isFirst) {
            this.map.setZoomAndCenter(
              15,
              new AMap.LngLat(arr[arr.length - 1].lng, arr[arr.length - 1].lat)
            );
          }
          this.isFirst = false;
        }

        this.speed();
      });
    },
    //清除轨迹
    clearTrack() {
      let that = this;
      let regionList = this.regionList;
      this.request
        .geoClearData({
          controllerCode: this.params.controllerCode,
          belongCustomerId: this.platformData.id,
        })
        .then(() => {
          this.setCart(this.params.controllerCode);
          this.params.endTime = "";
          this.params.maxCounts = "";
          this.params.startTime = "";
          this.dateList = [];
          this.speedList = [];
          this.paths = [];
          this.option = null;
          this.isFirst = true;
          this.speed();
          if (this.startMarker && this.endMarker && this.flightPath) {
            if (regionList[this.currentRegion].id != "cn") {
              this.map.remove(that.startMarker);
              this.map.remove(that.endMarker);
              this.map.remove(that.flightPath);
            } else {
              this.startMarker.setMap(null);
              this.endMarker.setMap(null);
              this.flightPath.setMap(null);
            }
          }
        });
    },
    //速度
    speed() {
      let date = this.dateList;
      let data = this.speedList;
      let that = this;
      this.option = {
        tooltip: {
          trigger: "axis",
        },
        title: {
          left: "left",
          text: `${that.$t("pages.operate.text106")}(km/h)`,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "10%"],
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        series: [
          {
            name: `${that.$t("pages.operate.text106")}(km/h)`,
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgba(31, 91, 204, 1)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#1F5BCC",
                },
                {
                  offset: 1,
                  color: "rgba(45, 110, 232, 0)",
                },
              ]),
            },
            data: data,
          },
        ],
      };
      this.option && this.myChart.setOption(this.option, true);
    },
    //时间格式转换
    formatDate(now) {
      var hour = now.getHours();
      var minute = now.getMinutes();
      var second = now.getSeconds();
      return hour + ":" + minute + ":" + second;
    },
  },
};
</script>

<style scoped>
.search {
  height: 40px;
}
.dilu-map {
  padding: 0 20px;
  box-sizing: border-box;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
#container {
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
}
.speed {
  width: 100%;
  height: 250px;
}
#dilu-speed {
  width: 100%;
  height: 100%;
}
.froms {
  display: flex;
  justify-content: space-between;
}
.from-li {
  display: flex;
}
.from-items {
  margin-right: 20px !important;
}
.btns {
  display: flex;
}
.dialog {
  display: flex;
  flex-direction: column;
}
</style>